import { withHeaders, instance as axiosInstance } from 'core/util';
import { getDefaultHeaders } from 'core/util/other';
import { Dictionary } from 'lib';

export const dictionaryListUrl = `/metadata/dictionary`;
export const useQueryProps = {
    retry: false,
    refetchOnWindowFocus: false,
};

export const getQueryData = async (
    url: string,
    token: string
): Promise<Dictionary[]> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response.data;
};

// this is the recursion part of getAvailableAttributeList and should not be exported
const getAttributeNamesList = (
    attributesList: string[],
    attributes: any,
    parentName?: string
): void => {
    attributes?.forEach((a: any) => {
        let name = a.name;
        if (parentName) {
            name = parentName + '.' + a.name;
        }
        attributesList.push(name);
        if (a.attributes) {
            getAttributeNamesList(attributesList, a.attributes, name);
        }
        if (a.nodeAttributes) {
            getAttributeNamesList(attributesList, a.nodeAttributes, name);
        }
    });
};

export const getAvailableAttributeList = (attributes: any): string[] => {
    let attributesList: string[] = [];
    getAttributeNamesList(attributesList, attributes);
    return attributesList;
};

export const capitalizeString = (inputString: string): string => {
    if (inputString.length === 0) {
        return inputString;
    }

    const firstLetter = inputString[0].toUpperCase();
    const restOfString = inputString.slice(1).toLowerCase();

    return firstLetter + restOfString;
};

export const dictionaryPresetColors: string[] = [
    '#53C3C0',
    '#F58838',
    '#69D7D2',
    '#FFC467',
    '#26C6DA',
    '#FFD14A',
    '#FF777B',
    '#52D9AE',
    '#3B9CF5',
    '#C87DC8',
    '#8C5ED6',
    '#068765',
    '#0A7A94',
    '#FF8A80',
    '#E86788',
    '#8D458D',
    '#2782D7',
    '#7548C5',
    '#26C6DA',
    '#C454A1',
    '#FCA84F',
    '#FB5E62',
];

export const getNormalizedDictionaryColors = (
    dictionaries: Dictionary[]
): Record<string, string> => {
    /**
     * Step 1: Set a map of all dictionary colors. This will either contain the value set from the dictionary editor
     * or an undefined value that will be populated below.
     */
    const colors = dictionaries.reduce((acc: any, dictionary: Dictionary) => {
        acc[dictionary.name] = dictionary?.layoutMetadata?.color;
        return acc;
    }, {});

    /**
     * Step 2: Get the list of all color keys that are undefined (haven't been set via dictionary editor).
     */
    const undefinedNodeColors = Object.keys(colors).filter(
        (key) => colors[key] === undefined
    );

    /**
     * Step 3: For every color key, grab the new color value from the dictionaryPresetColors list in order, then update
     * any undefined value from the original color map with the new updated color.
     */
    for (let i = 0; i < undefinedNodeColors.length; i++) {
        const currentDictionary = undefinedNodeColors[i];
        const colorIndex = i % dictionaryPresetColors.length;
        colors[currentDictionary] = dictionaryPresetColors[colorIndex];
    }

    return colors;
};
